@import 'styles/mixins';
@import 'styles/variables';

.wrapper {
  position: absolute;
  left: 50%;
  transform: translateX(-50%) translateY(-100%);
}

.promptContainer {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 5px;
}

.buttons {
  gap: 2px;
}

.commentPopover {
  padding: 0;
  overflow: visible;
}
